export default __webpack_public_path__ + "static/media/cv_academic_en.ae17927a.pdf";